import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

const toastError = err => {
	const silentMessages = ["ERR_UNAUTHORIZED", "ERR_SESSION_EXPIRED"];
  const errorResponseMsg = err?.response?.data?.error || err?.response?.data?.message;
  // Ignorar erros 401 durante logout
  if (err?.response?.status === 401 || 
    err?.response?.status === 403 || 
    silentMessages.includes(errorResponseMsg) ||
    silentMessages.includes(err)) {
    // const { getIsLoggingOut } = require("../utils/logoutManager");
    // if (getIsLoggingOut()) {
    //   return;
    // }
	console.warn("Auth Error Silenced:", errorResponseMsg || "Unauthorized Access");
    return; // Sai da função sem disparar o toast.error
  }
  
  const errorMsg = typeof err === 'string'
    ? err
    : err.response?.data?.error || err.response?.data?.message || err.message || "ERR_UNKNOWN";

	if (errorMsg) {
		// Tratamento especial para ERR_OTHER_OPEN_TICKET com informações do usuário
		if (errorMsg.startsWith('ERR_OTHER_OPEN_TICKET:')) {
			const userName = errorMsg.split(':')[1];
			const message = `Já existe um atendimento aberto para esse contato, com o atendente ${userName}`;
			toast.error(message, {
				toastId: 'ERR_OTHER_OPEN_TICKET',
				autoClose: 4000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		}
		
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		}
	} if (isString(err)) {
		toast.error(err);
		return
	} else {
		toast.error("An error occurred!");
		return
	}
};

export default toastError;
